import { useFetchMixAPi1, useFetchMxfNestApi } from "hooks";
import { getURLWithParams } from "utils/context";

export const useCodigoSpedPisCofins = (params = {}) =>
  useFetchMixAPi1(
    getURLWithParams(`/legislacao/alertas/natureza-receita`, params),
  );

export const useAliqCbenef = (params = {}) =>
  useFetchMixAPi1(
    getURLWithParams(`/legislacao/alertas/aliquota-cbenef`, params),
  );

export const useCategoriaSemNotaVinculada = (params = {}) =>
  useFetchMixAPi1(
    getURLWithParams(`/legislacao/alertas/vinculo-direto`, params),
  );

export const useFaltaEspecificacao = (params = {}) =>
  useFetchMixAPi1(
    getURLWithParams(`/legislacao/alertas/especificacao`, params),
  );

export const useFaltaCbenef = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/legislacao/alertas/cbenef`, params));

export const useCategoriasSemCest = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/legislacao/alertas/cest`, params));

export const usePerformanceChart = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/legislacao/desempenho-chart`, params));

export const useTopUfs = () =>
  useFetchMixAPi1(getURLWithParams(`/legislacao/alertas/qtd-uf`));

export const useCategorySemRegra = (params = {}) =>
  useFetchMixAPi1(
    getURLWithParams(`/legislacao/alertas/categorias-sem-regra`, params),
  );

export const useCategoryWithoutIbs = (params = {}) =>
  useFetchMxfNestApi(getURLWithParams(`/mxf-categorias/without-ibs`, params));
